import { when } from 'ramda'
import { parse } from 'qs'

export const transformJsonToForm = (data) => Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')

export const isHashToken = hash => /access_token|id_token|error|request_login/.test(hash)

export const getHashVariables = when(isHashToken, parse)
